import { axiosInstance } from "./";

const roleDetails = async ({ id }) =>
  await axiosInstance.get(`/api/Role/View?id=${id}`);

const rolesList = async ({ params }) =>
  await axiosInstance.get("/api/Role/Get", {
    params,
    paramsSerializer: { indexes: null }
  });

const getModulesPermissionsRequest = async () =>
  await axiosInstance.get("/api/ModulePermission/Get");

const addRoleRequest = async (data) =>
  await axiosInstance.post("/api/Role/Add", data);

const getEditRoleDataRequest = async (params) =>
  await axiosInstance.get("/api/Role/ViewEdit", { params });

const editRoleRequest = async (data) =>
  await axiosInstance.put("/api/Role/Edit", data);

const deleteRoleRequest = async ({ data }) =>
  await axiosInstance.put("/api/Role/Delete", data);

export {
  rolesList,
  roleDetails,
  getModulesPermissionsRequest,
  addRoleRequest,
  getEditRoleDataRequest,
  editRoleRequest,
  deleteRoleRequest
};
